import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { AI_DESCRIPTION } = STEP_IDENTIFIER_NAME;

export const aiDescription: StepConfig = {
	name: AI_DESCRIPTION,
	isAuthenticationRequired: false,
	isEnabled: (fcm) => fcm.starterAIPrompt.isEnabled,
};
